import React from 'react'
import DashboardMenuIcon from './assets/icons/DashboardMenuIcon.png'
import ClientMenuIcon from './assets/icons/Client.png'
import ProjectMenuIcon from './assets/icons/Project.png'
import InvoiceMenuIcon from './assets/icons/Invoice.png'
import ExpenseMenuIcon from './assets/icons/Expense.png'
import EmployeeMenuIcon from './assets/icons/Employee.png'
import UserMenuIcon from './assets/icons/User.png'
import TimeOffMenuIcon from './assets/icons/TimeOff.png'
import TimeOffBalance from './assets/icons/TimeOffBalance.png'
import TimeOffRequest from './assets/icons/TimeOffRequest.png'
import CompanyTimeOff from './assets/icons/CompanyTimeOff.png'
import AssetMenuIcon from './assets/icons/Asset.png'
import GeneralSettingMenuIcon from './assets/icons/GeneralSetting.png'
import CompanyPolicy from './assets/icons/CompanyPolicy.png'
import PolicyType from './assets/icons/PolicyType.png'
import PolicyList from './assets/icons/PolicyList.png'
import LetterNoTracker from './assets/icons/LetterTracker.png'
import { CImage, CNavItem, CNavGroup } from '@coreui/react-pro'

const _nav = [
  {
    component: CNavItem,
    name: 'Dashboard',
    to: '/',
    icon: <CImage fluid src={DashboardMenuIcon} className='me-2' />,
    roles: [1]
  },
  {
    component: CNavItem,
    name: 'Client',
    to: '/client/list',
    icon: <CImage fluid src={ClientMenuIcon} className='me-2' />,
    roles: [1, 2]
  },
  {
    component: CNavItem,
    name: 'Project',
    to: '/project/list',
    icon: <CImage fluid src={ProjectMenuIcon} className='me-2' />,
    roles: [1, 2]
  },
  {
    component: CNavItem,
    name: 'Invoice',
    to: '/invoice/list',
    icon: <CImage fluid src={InvoiceMenuIcon} className='me-2' />,
    roles: [1]
  },
  {
    component: CNavItem,
    name: 'Expense',
    to: '/expense/list',
    icon: <CImage fluid src={ExpenseMenuIcon} className='me-2' />,
    roles: [1]
  },
  {
    component: CNavItem,
    name: 'Employee',
    to: '/employee/list',
    icon: <CImage fluid src={EmployeeMenuIcon} className='me-2' />,
    roles: [1]
  },
  {
    component: CNavItem,
    name: 'User',
    to: '/user/list',
    icon: <CImage fluid src={UserMenuIcon} className='me-2' />,
    roles: [1]
  },
  {
    component: CNavGroup,
    name: "Time-Off",
    icon: <CImage fluid src={TimeOffMenuIcon} className="me-2" />,
    roles: [1],
    items: [
      {
        component: CNavItem,
        name: "Time-Off Balance",
        to: "/time-off-balance/list",
        icon: <CImage fluid src={TimeOffBalance} className="me-2" />,
        roles: [1],
      },
      {
        component: CNavItem,
        name: "Time-Off Request",
        to: "/time-off-request/list",
        icon: <CImage fluid src={TimeOffRequest} className="me-2" />,
        roles: [1],
      },
      {
        component: CNavItem,
        name: "Company Time Off",
        to: "/company-time-off/list",
        icon: <CImage fluid src={CompanyTimeOff} className="me-2" />,
        roles: [1],
      },
    ],
  },
  {
    component: CNavGroup,
    name: 'Company Policy',
    icon: <CImage fluid src={CompanyPolicy} className='me-2' />,
    roles: [1, 2],
    items: [
      {
        component: CNavItem,
        name: 'Policy List',
        to: '/company-policy/list',
        icon: <CImage fluid src={PolicyList} className='me-2' />,
        roles: [1, 2]
      },
      {
        component: CNavItem,
        name: 'Policy Types',
        to: '/policy-type/list',
        icon: <CImage fluid src={PolicyType} className='me-2' />,
        roles: [1, 2]
      }
    ]
  },
  {
    component: CNavItem,
    name: 'Asset',
    to: '/asset/list',
    icon: <CImage fluid src={AssetMenuIcon} className='me-2' />,
    roles: [1]
  },
  {
    component: CNavItem,
    name: 'Letter no. Tracker',
    to: '/letter-no-tracker/list',
    icon: <CImage fluid src={LetterNoTracker} className='me-2' />,
    roles: [1, 2]
  },
  {
    component: CNavItem,
    name: 'General Setting',
    to: '/generalsetting',
    icon: <CImage fluid src={GeneralSettingMenuIcon} className='me-2' />,
    roles: [1]
  }
]

export default _nav
